type LiveChatVisibility = {
  visibility?: "maximized" | "minimized" | "hidden";
};

export type LiveChatCustomer = {
  name?: string;
  email?: string;
};

declare global {
  interface Window {
    __lc?: {
      license?: number;
      integration_name?: string;
      product_name?: string;
      asyncInit?: boolean;
      visitor?: {
        name?: string;
        email?: string;
      };
    };
    LiveChatWidget?: {
      call: (method: string, ...args: unknown[]) => void;
      on: (event: string, callback: (data: LiveChatVisibility) => void) => void;
      off: (event: string, callback: (data: LiveChatVisibility) => void) => void;
    };
  }
}

let sidebarModeInitialized = false;
let latestCustomer: LiveChatCustomer | null = null;

function handleVisibilityChanged(data: LiveChatVisibility) {
  if (data.visibility === "maximized") {
    document.body.classList.add("livechat-window-open");
    return;
  }

  document.body.classList.remove("livechat-window-open");

  if (data.visibility === "minimized") {
    window.LiveChatWidget?.call("hide");
  }
}

function hideFloatingWidget() {
  window.LiveChatWidget?.call("hide");
  document.body.classList.remove("livechat-window-open");
}

function applyCustomerIdentity(customer: LiveChatCustomer) {
  const name = customer.name?.trim();
  const email = customer.email?.trim();
  if (!name && !email) return;

  // Helps when the snippet re-inits / reads visitor config.
  window.__lc = window.__lc || {};
  window.__lc.visitor = {
    ...(name ? { name } : {}),
    ...(email ? { email } : {}),
  };

  const widget = window.LiveChatWidget;
  if (!widget?.call) return;

  if (name) {
    widget.call("set_customer_name", name);
  }
  if (email) {
    widget.call("set_customer_email", email);
  }
}

/** Prefill LiveChat with the logged-in dashboard user. */
export function identifyLiveChatCustomer(customer: LiveChatCustomer) {
  latestCustomer = customer;
  applyCustomerIdentity(customer);
}

/** Hide default bubble; chat opens from the left sidebar only. */
export function initLiveChatSidebarMode() {
  if (sidebarModeInitialized || typeof window === "undefined") return;
  sidebarModeInitialized = true;

  const widget = window.LiveChatWidget;
  if (!widget) return;

  const onReady = () => {
    hideFloatingWidget();
    if (latestCustomer) {
      applyCustomerIdentity(latestCustomer);
    }
    widget.on("visibility_changed", handleVisibilityChanged);
  };

  widget.on("ready", onReady);
}

export function openLiveChat() {
  if (latestCustomer) {
    applyCustomerIdentity(latestCustomer);
  }
  window.LiveChatWidget?.call("maximize");
}
